import { render, staticRenderFns } from "./ModalLegalRefer.vue?vue&type=template&id=6dead8e8&scoped=true&"
import script from "./ModalLegalRefer.vue?vue&type=script&lang=js&"
export * from "./ModalLegalRefer.vue?vue&type=script&lang=js&"
import style0 from "./ModalLegalRefer.vue?vue&type=style&index=0&id=6dead8e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dead8e8",
  null
  
)

export default component.exports